import { InjectionToken } from '@angular/core';

export interface ArchiveDocumentConfig {
  apiUrl: string;
}

export const ARCHIVE_DOCUMENT_CONFIG = new InjectionToken<ArchiveDocumentConfig>('ArchiveDocumentConfig');
